// ---------------------------------------------------------------------------
// MISE À JOUR AUTOMATIQUE APRÈS UN DÉPLOIEMENT (Toji, 22/10)
// ---------------------------------------------------------------------------
// Le serveur annonce la version du bundle sur /healthz. Quand elle diffère de
// celle que la page a chargée (`/app.js?v=…`), on recharge — mais jamais au
// milieu d'un film : `decider` est PURE, c'est elle que l'essai éprouve.
//   - lecture en cours ............ jamais (on attend pause, sortie, épisode suivant)
//   - lecture en pause ≥ 30 s ..... recharge ; l'adresse porte l'épisode et la
//                                   reprise rend la même seconde
//   - saisie ou menu ouvert ....... on attend
//   - ailleurs (accueil, fiche) ... tout de suite
// ---------------------------------------------------------------------------

export const PAUSE_MIN_MS = 30_000;
export const RELEVE_MS = 120_000;

/** 'recharger' | 'attendre' — PURE. */
export function decider({ perimee, lecture = false, enCours = false, pauseDepuisMs = 0, saisie = false, menu = false } = {}) {
  if (!perimee || saisie || menu) return 'attendre';
  if (!lecture) return 'recharger';
  return !enCours && pauseDepuisMs >= PAUSE_MIN_MS ? 'recharger' : 'attendre';
}

/** La version que CETTE page a chargée : le `?v=` de son module. */
export function versionChargee(url = import.meta.url) {
  try { return new URL(url).searchParams.get('v'); } catch { return null; }
}

/**
 * Surveille la version. `etat()` rend { lecture, enCours, pauseDepuisMs, saisie, menu }.
 * Rend { verifier } (pour les essais) ; `recharger` est injectable.
 */
export function surveillerVersion({ etat, chargee = versionChargee(), url = '/healthz', recharger = () => location.reload(), releve = RELEVE_MS } = {}) {
  let perimee = false;
  let enVol = false;
  const verifier = async () => {
    if (!chargee) return 'inconnue';
    if (!perimee && !enVol) {
      enVol = true;
      try {
        const r = await fetch(url, { cache: 'no-store' });
        const v = r.ok ? (await r.json())?.version : null;
        perimee = !!v && String(v) !== String(chargee);
      } catch { /* serveur coupé : on réessaiera */ } finally { enVol = false; }
    }
    const d = decider({ perimee, ...etat() });
    if (d === 'recharger') recharger();
    return d;
  };
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => { if (!document.hidden) verifier(); });
    window.addEventListener('online', verifier);
    // unref : sous Node (essais), le relevé ne doit pas garder le processus en vie.
    setInterval(verifier, releve).unref?.();
  }
  return { verifier };
}
